import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Formatea un valor como moneda
 * @param {number} value - Valor a formatear
 * @param {string} moneda - Código de moneda: 'COP' o 'USD' (default: 'COP')
 * @returns {string} Valor formateado con símbolo de moneda
 */
export function formatCurrency(value, moneda = 'COP') {
  if (value === null || value === undefined) {
    return moneda === 'USD' ? 'US$ 0.00' : '$ 0';
  }
  
  if (moneda === 'USD') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }
  
  // Default: COP
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDate(dateString) {
  if (!dateString) return '';
  
  try {
    // Si es una fecha ISO con timestamp (ej: 2024-01-15T10:30:00.000Z)
    if (dateString.includes('T')) {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      return new Intl.DateTimeFormat('es-CO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date);
    }
    
    // Parse the date string as local date to avoid timezone issues
    const parts = dateString.split('-');
    if (parts.length === 3) {
      const date = new Date(parts[0], parts[1] - 1, parts[2]);
      if (isNaN(date.getTime())) return '';
      return new Intl.DateTimeFormat('es-CO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date);
    }
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('es-CO', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  } catch (error) {
    console.error('Error formatting date:', dateString, error);
    return '';
  }
}

export function formatPercent(value) {
  if (value === null || value === undefined) return '0%';
  return `${value.toFixed(1)}%`;
}

// Helper to format date as YYYY-MM-DD in local timezone
function formatLocalDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getDateRangePreset(preset) {
  const today = new Date();
  let startDate, endDate;

  switch (preset) {
    case 'today':
      startDate = today;
      endDate = today;
      break;
    case 'week':
      startDate = new Date(today);
      startDate.setDate(today.getDate() - today.getDay());
      endDate = today;
      break;
    case 'month':
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = today;
      break;
    case 'year':
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = today;
      break;
    default:
      return { startDate: null, endDate: null };
  }

  return {
    startDate: formatLocalDate(startDate),
    endDate: formatLocalDate(endDate),
  };
}

export { formatLocalDate };
